export default __webpack_public_path__ + "static/media/clear.81c8d67f.png";